import { graphql } from "~/gql";

export const MATTER_COLLABORATORS_QUERY = graphql(/* GraphQL */ `
  query FindMatterCollaboratorUserIds($matterId: Int!) {
    matterCollaborators(matterId: $matterId) {
      id
      user {
        id
        userName
        displayName
      }
    }
  }
`);
